import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import {
  CloseButton,
  DialogHeaderRow,
  DialogModalTitle,
  DialogStorageIcon,
  RagStorageModalHeader,
} from '../styled';

interface DialogHeaderProps {
  isEditMode: boolean;
  onClose: () => void;
}

const DialogHeader = ({ isEditMode, onClose }: DialogHeaderProps) => {
  const { t } = useTranslation('common');

  return (
    <RagStorageModalHeader>
      <DialogHeaderRow>
        <DialogStorageIcon />
        <DialogModalTitle>
          {!isEditMode
            ? t('assistant.ragStorageDialog.createContext')
            : t('assistant.ragStorageDialog.updateContext')}
        </DialogModalTitle>
      </DialogHeaderRow>
      <CloseButton
        onClick={onClose}
        size="small"
        data-testid="context-dialog-close-btn"
      >
        <CloseIcon />
      </CloseButton>
    </RagStorageModalHeader>
  );
};

export default DialogHeader;
